import { closeModal, openModal } from 'components/modal/modules/dispatcher/methods';
import ImportSettingsModal from 'pages/manage/events/edit/modules/ImportSettingsModal'
import React from 'react';

export default class ImportEvent extends React.Component<{ [label: string]: any }, { [label: string]: any }> {
  public state = {

  };

  constructor(props) {
    super(props);
  }

  public handleOpenCreateModal() {
    const content = (
      <ImportSettingsModal
        onClose={() => closeModal()}
        eventId={this.props.eventId}
      />
    );

    openModal(content, "Import Settings", [
    ]);
  }
  public render() {
    return (
      <div>
        <div
          className='new-button-white-3'
          onClick={e =>
            this.handleOpenCreateModal()
          }
          style={{ width: '140px', cursor: 'pointer' }}
        >
          <div className="small-split-768" />
          IMPORT SETTINGS
          </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/manage/events/edit/modules/ImportEvent.tsx